import React from "react"

import {hasProperty, formatText} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';


class ViewDesignItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.data = {};
        this.data.DesignItem = null;

        if (this.props.DesignItem) {
            this.data.DesignItem = this.props.DesignItem; 
        }

        this.data.id = null;
        if (this.props.id) {
            this.data.id = this.props.id; 
        }
    }

    componentDidMount() {
        if (this.data.DesignItem) {
            this.setState({"isLoaded": true});
            return;
        }
    };

    view(json) {
        if (json) {
            return(
                <PD.Table className="panel">
                    <PD.Tbody>                                

                        {hasProperty(json, 'name') &&
                            <PD.Tr>                                
                                <PD.Th>Name</PD.Th><PD.Td>{json.name}</PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json, 'reference') &&
                            <PD.Tr>                                
                                <PD.Th>Reference</PD.Th><PD.Td>{json.reference}</PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json, 'definition') &&
                            <PD.Tr>
                                <PD.Th>Definition</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.definition}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json, 'sources') &&
                            <PD.Tr>
                                <PD.Th>Sources</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.sources}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json, 'rules') &&
                            <PD.Tr>
                                <PD.Th>Rules</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.rules}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json, 'resources') &&
                            <PD.Tr>
                                <PD.Th>Resources</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.resources}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json, 'alternatives') &&
                            <PD.Tr>
                                <PD.Th>Alternatives</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.alternatives}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json, 'stakeholders') &&
                            <PD.Tr>
                                <PD.Th>Stakeholders</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.stakeholders}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json, 'law') &&
                            <PD.Tr>
                                <PD.Th>Law</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.law}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json, 'standards') &&
                            <PD.Tr>
                                <PD.Th>Standards</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.standards}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json, 'status') &&
                            <PD.Tr>                                
                                <PD.Th>Status</PD.Th><PD.Td>{json.status}</PD.Td>
                            </PD.Tr>
                        }

                    </PD.Tbody>
                </PD.Table>
            )
        }
    }

    render() {
        return (
            <div>
                {this.view(this.data.DesignItem)}
            </div>
        );
    };
};

export default ViewDesignItem;
